(function () {

  const widget = document.getElementById(
    "FloatingProductVideo"
  );

  if (!widget) {
    return;
  }

  const video = widget.querySelector("video");

  const toggleButton = widget.querySelector(
    "[data-floating-video-toggle]"
  );

  const closeButton = widget.querySelector(
    "[data-floating-video-close]"
  );

  const playIcon = widget.querySelector(
    "[data-floating-video-play-icon]"
  );

  const pauseIcon = widget.querySelector(
    "[data-floating-video-pause-icon]"
  );

  if (!video) {
    widget.remove();
    return;
  }

  function updateButton() {

    if (video.paused) {

      playIcon.hidden = false;
      pauseIcon.hidden = true;

      toggleButton.setAttribute(
        "aria-label",
        "Play product video"
      );

    } else {

      playIcon.hidden = true;
      pauseIcon.hidden = false;

      toggleButton.setAttribute(
        "aria-label",
        "Pause product video"
      );

    }

  }

  video.muted = true;
  video.playsInline = true;

  video.play().catch(function () {
    updateButton();
  });

  toggleButton.addEventListener(
    "click",
    function () {

      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }

    }
  );

  closeButton.addEventListener(
    "click",
    function () {

      video.pause();

      widget.classList.add(
        "is-hidden"
      );

    }
  );

  video.addEventListener(
    "play",
    updateButton
  );

  video.addEventListener(
    "pause",
    updateButton
  );

  video.addEventListener(
    "loadeddata",
    function () {

      widget.classList.add(
        "is-ready"
      );

    },
    {
      once: true
    }
  );

  setTimeout(
    function () {

      widget.classList.add(
        "is-ready"
      );

    },
    1000
  );

})();